module.exports = __webpack_public_path__ + "img/hometoponecopy.8ae56750.jpg";